// Maps contract revert codes (E1..E22) and wallet errors to human messages.

const CODE_MAP = {
  E1: 'Only the owner can do this.',
  E2: 'Only an admin can do this.',
  E3: 'This wallet is already registered.',
  E4: 'USDT transfer failed. Check your balance and approval.',
  E5: 'You are not registered yet. Please register first.',
  E6: 'Invalid package selected.',
  E7: 'This package is already active.',
  E8: 'Activate the previous package first.',
  E9: 'This package is not active.',
  E10: 'Amount must be greater than zero.',
  E11: 'You are not eligible for this pool.',
  E12: 'No new rounds available to claim.',
  E13: 'Nothing available to claim right now.',
  E14: 'Reserve pool is empty.',
  E15: 'Invalid router amount.',
  E16: 'Invalid recipient address.',
  E17: 'Percentage cannot exceed 100.',
  E18: 'Too many users in one batch.',
  E19: 'User is not active.',
  E20: 'User is not virtual.',
  E21: 'Level must be between 1 and 12.',
  E22: 'All 9 packages must be active first.',
};

export function parseError(err) {
  if (!err) return 'Something went wrong.';

  // User rejected in wallet
  const code = err.code;
  if (code === 4001 || code === 'ACTION_REJECTED') {
    return 'Transaction rejected in your wallet.';
  }
  if (code === -32002) {
    return 'A wallet request is already pending. Open your wallet.';
  }

  // Dig out the revert reason string from various ethers shapes
  const blob = JSON.stringify({
    a: err.reason,
    b: err.data && err.data.message,
    c: err.error && err.error.message,
    d: err.message,
  });

  // Match a bare E-code like "E4"
  const m = blob.match(/\bE(\d{1,2})\b/);
  if (m) {
    const key = 'E' + m[1];
    if (CODE_MAP[key]) return CODE_MAP[key];
  }

  if (/insufficient funds/i.test(blob)) return 'Not enough BNB for gas fees.';
  if (/transfer amount exceeds balance/i.test(blob)) return 'Insufficient USDT balance.';
  if (/transfer amount exceeds allowance/i.test(blob)) return 'Please approve USDT first.';
  if (/user denied|user rejected/i.test(blob)) return 'Transaction rejected in your wallet.';
  if (err.reason) return err.reason;

  return 'Transaction failed. Please try again.';
}
